import { render, staticRenderFns } from "./swiperSetting.vue?vue&type=template&id=24c5cd1e&scoped=true&"
import script from "./swiperSetting.vue?vue&type=script&lang=js&"
export * from "./swiperSetting.vue?vue&type=script&lang=js&"
import style0 from "./swiperSetting.vue?vue&type=style&index=0&id=24c5cd1e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c5cd1e",
  null
  
)

export default component.exports